(function () {
  const PredictiveSearch = {
    drawer: document.querySelector('[data-search-drawer]'),
    input: document.querySelector('[data-search-input]'),
    results: document.querySelector('[data-search-results]'),
    form: document.querySelector('[data-search-form]'),

    init() {
      if (!this.input || !this.results) return;

      this.input.addEventListener('input', Branzos.debounce(() => {
        this.search(this.input.value);
      }, 250));

      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (this.input.value.trim()) {
            window.location.href = `/search?q=${encodeURIComponent(this.input.value.trim())}`;
          }
        }
      });

      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          if (!this.input.value.trim()) e.preventDefault();
        });
      }
    },

    open() {
      if (!this.drawer) return;
      Branzos.openDrawer(this.drawer);
      setTimeout(() => this.input.focus(), 380);
    },

    search(query) {
      const q = query.trim();
      if (!q) {
        this.results.innerHTML = this.emptyState(false);
        return;
      }

      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title`;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((res) => {
          if (!res.ok) throw new Error('search failed');
          return res.json();
        })
        .then((data) => this.render(data, q))
        .catch(() => {
          this.results.innerHTML = this.emptyState(false);
        });
    },

    render(data, q) {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

      if (!products.length && !collections.length) {
        this.results.innerHTML = this.emptyState(true, q);
        return;
      }

      let html = '';

      if (products.length) {
        html += `
          <div class="predictive-search__group">
            <p class="predictive-search__group-title">Products</p>
            ${products.map((p) => this.productItem(p)).join('')}
          </div>`;
      }

      if (collections.length) {
        html += `
          <div class="predictive-search__group">
            <p class="predictive-search__group-title">Categories</p>
            ${collections.map((c) => this.collectionItem(c)).join('')}
          </div>`;
      }

      html += `
        <div class="search-suggestions">
          <a class="search-suggestion__chip" href="/search?q=${encodeURIComponent(q)}">
            View all results for "${q}" →
          </a>
        </div>`;

      this.results.innerHTML = html;
    },

    productItem(p) {
      const img = p.featured_image && p.featured_image.url
        ? `<img class="predictive-search__thumb" src="${p.featured_image.url}&width=120" alt="${p.title}" loading="lazy">`
        : `<span class="predictive-search__thumb predictive-search__thumb--emoji">🍬</span>`;
      const rawPrice = parseFloat(p.price);
      const price = !isNaN(rawPrice)
        ? `<span class="price"><span class="price__current">${window.ShopifyTheme.money(Math.round(rawPrice * 100))}</span></span>`
        : '';
      return `
        <a class="predictive-search__item" href="/products/${p.url.split('/').pop()}">
          ${img}
          <span>
            <p class="predictive-search__name">${p.title}</p>
            <span class="predictive-search__type">${price}</span>
          </span>
        </a>`;
    },

    collectionItem(c) {
      return `
        <a class="predictive-search__item" href="/collections/${c.url.split('/').pop()}">
          <span class="predictive-search__thumb predictive-search__thumb--emoji">🍬</span>
          <span>
            <p class="predictive-search__name">${c.title}</p>
            <span class="predictive-search__type">Collection</span>
          </span>
        </a>`;
    },

    emptyState(searched, q) {
      const label = searched
        ? `<span class="predictive-search__empty-emoji">🍭</span>No sweets found for "${q}"`
        : `<span class="predictive-search__empty-emoji">🔍</span>Search sweets, brands and categories`;
      return `<div class="predictive-search__empty">${label}</div>`;
    },
  };

  window.ShopifyPredictiveSearch = PredictiveSearch;
  Branzos.onLoad(() => PredictiveSearch.init());
})();
